export enum GetDownloadPDFUrlErrorCodes {
  GET_DOCUMENT_BY_COMPONENT_ID_NO_PCF_STATEMENTS_FOUND_IN_DSS = 'GET_DOCUMENT_BY_COMPONENT_ID_NO_PCF_STATEMENTS_FOUND_IN_DSS',
  GET_DOCUMENT_BY_COMPONENT_ID_NO_MATCHING_REGION_DOC = 'GET_DOCUMENT_BY_COMPONENT_ID_NO_MATCHING_REGION_DOC',
}
